import history from "../../routes/history"
export const Types = {
    LOADING: "app/loading",
    PAGE: "app/page",
    LOGOUT: "app/logout"
}

const INITIAL_STATE = {
    loading: false,
    page: "/"
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case Types.FECTH: {
            console.log("fech no reducer do app")
            break
        }
        case Types.LOADING:
            return { ...state, loading: action.loading }

        case Types.PAGE:
            return { ...state, page: action.page }

        case Types.LOGOUT:
            return { ...state, logout: action.logout }

        default:
            return state
    }
}

export const Creators = {
    loadding: loading => {
        return {
            type: Types.LOADING,
            loading
        }
    },
    page: page => dispatch => {
        dispatch({
            type: Types.PAGE,
            page: page
        })
        history.push(page)
    },
    logout: () => dispatch => {
        dispatch({
            type: Types.PAGE,
            page: "/logout"
        })
        history.push("/perfil")
    }
}
